import { includes } from 'lodash-es'

/**
 *
 * ! DO NOT EXTEND THIS LIST - INSTEAD THINK ABOUT A DIFFERENT SOLUTION !
 *
 * A list of all third party freight forwarders that only have restricted platform access.
 * 3rd Party Freight Forwarders need access to FortoX to manage the shipment of purchase orders that are not shipped
 * by Forto. The only way to give them access to Forto is through a customer account.
 * But external Freight Forwarders should only have access to user and account management functionality. They should
 * especially NOT have access to quotes and rates.
 * In order to implement this requirement in this quarter, we hard code the list of Freight Forwarders here. We are
 * are not expecting to onboard any other Freight Forwarders. If so, this configuration needs to happen on the back
 * end.
 * See https://forto.atlassian.net/browse/FH-14109 for more details.
 */
const thirdPartyFreightForwarderWithRestrictedPlatformAccessIds: ReadonlyArray<string> = [
  'C-28861',
  'C-29481', // Zencargo
  'C-29840', // Rhenus FH-17411 FH-17379
]
export function isThirdPartyFreightForwarderWithRestrictedPlatformAccess(customerId: string): boolean {
  return includes(thirdPartyFreightForwarderWithRestrictedPlatformAccessIds, customerId)
}
